<template>
  <div>
    <div class="u-Clear c-ibForm-wrap" 
    :class="{
      'c-ibForm-wrap--first' : this.firstSection, 
      'c-ibForm-wrap--no-padding-top': this.noPadding,
      'u-Pa-b-0': this.noPaddingBottom
    }">
      <div class="c-ibForm-flex-header-and-note">
        <div class="c-ibForm-wrap--full c-ibForm-wrap--half-note"
           @click.prevent="headingModalExists ? showHeadingModal() : ''"
           v-if="this.heading.length > 0">
          <h2 class="c-ibForm-inner-h">
            {{qResultsLang[this.heading] ? qResultsLang[this.heading] : this.heading}}<span :style="{display: this.headingModal ? 'inline-block' : 'none'}" class="o-Question"></span>
          </h2>
          <span class="c-ibForm-inner-h-description" v-if="qResultsLang.headerDescription && qResultsLang.headerDescription[this.heading]">
            {{ qResultsLang.headerDescription[this.heading] }}
          </span>
        </div>
      </div>
      <div :class="headingModal != 'coveragedates' ? 'c-ibApp__flex--wrap' : 'c-ibForm-input__dateRange'">
        <!-- START main for loop -->
        <div v-if="checkBooleanFromString(x.conditions)"
           :key="i"
           v-for="(x,i) in fields"
           :class="x.l === 'full' && x.model != 'startDate' && x.model != 'endDate' ? 'c-ibForm-wrap--half-r c-ibForm-wrap--trip-item3'
               : x.l === 'half' && x.model != 'startDate' && x.model != 'endDate' && x.model != 'signature' ? 'c-ibForm-wrap--half-r'
               : x.model === 'startDate' || x.model == 'signature' ? 'c-ibForm-wrap--half' : x.model === 'endDate' ? 'c-ibForm-wrap--half-r' : 'c-ibForm-wrap--half-r c-ibForm-wrap--trip-item2'">
          <label  @click.prevent="x.modal !== null && x.modal !== undefined ? $emit('show-modal','/guide/terms?section='+x.modal) : ''"
              class="c-ibForm-label"
              :id="x.labelId ? x.labelId : null"
              :style="{'word-spacing': x.label === 'departResidenceCountry' && sizeLarge ? '3.5px' : 'normal',
                  'display': x.label ? 'block' : 'none'}"
              >
              <!-- next line must all be on same line otherwise 1) Extra space will be added, 2) <nobr> will not prevent question marks from wrapping -->
            <span>{{qResultsLang[x.label] ? qResultsLang[x.label] : x.label}}</span><span v-if="x.optional"><i>&nbsp;{{'('+qResultsLang.optional+')'}}</i></span><nobr><span v-if="x.type ==='datepicker'">&nbsp;({{qResultsLang.dateFormat}})</span><span :style="{display: x.modal === null || x.modal === undefined ? 'none' : 'inline-block'}" class="o-Question"></span></nobr>
          </label>
          <!-- INPUT -->
          <div class="c-ibForm-cc" v-if="x.type === 'input' || x.type === 'email'">
          <input
            v-model.trim="data.form[x.model]"
            class="c-ibForm-input"
            :class="x.disabled ? 'c-ibForm-input--disabled' : ''"
            :readonly="readonly"
            :type="x.type == 'email' ? 'email': 'text'"
            autocomplete="nope"
            :disabled="x.disabled ? x.disabled : null"
            :id="x.id ? x.id : ''"
            :maxlength="x.maxlength"
            @change="x.liveErrors && $v.form[x.model].$touch()"
          />
               <!-- for images in inputs -->
              <span v-if="x.imageInInput" class="c-ibForm-cc-type">
                <img :src="x.imageInInput"/>
              </span>
          </div>
          <!-- SELECT -->
          <select v-else-if="x.type === 'select'"
               v-model="data.form[x.model]"
               class="c-ibForm-input-select"
               :id="x.id ? x.id : ''"
               >
               <option value="" selected disabled>{{qResultsLang.select}}</option>
               <option :key="n" v-for="(a,n) in x.selectOptions" :value="a.value">{{qResultsLang[a.text] || a.text}}</option>

          </select>
          <!-- PHONE -->
          <div v-else-if="x.type === 'phone'" class="c-ibForm-cntry-code-phone" :id="x.phoneId+'-parent'">
            <phone-code :all-countries="ibjs.countries" :change-method="'phone-updated'" @phone-updated="makeContactAjaxCall" v-model="data.form[x.model]" :default-val="data.form[x.model]" :ref-name="x.model" :name="x.id" :input-id="x.id + 'Input'"></phone-code>
          </div>
          <!-- DATE PICKER -->
          <template v-else-if="x.type ==='datepicker'">
            <template v-if="x.model === 'startDate'">
              <date-picker 
                  class="c-ibForm-input__date-picker"
                  v-model.trim="data.form[x.model]"
                  :start-date="setDate"
                  @set-focus="setFocus" 
                  @remove-prefocus="removeFocus" 
                  inline-template
              >
                  <div class="c-ibForm-input__Coverage u-Relative">
                      <input 
                          type="tel" 
                          class="c-ibForm-input__Coverage-input" 
                          :id="x.id"
                          :value="value || ''"
                          autocomplete="off"
                          @input="handleInputEvt"
                          maxlength="10"
                          :placeholder="x.placeholder || ''" 
                          @blur="$emit('remove-prefocus', 'start')"
                          @focus="$emit('set-focus', 'start')"
                      >
                      <span class="o-Icon-menu__date">
                          <svg class="c-ibForm-input__Coverage-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.39996 0C6.06258 0 6.59976 0.511607 6.59976 1.14268V2.28536C6.59976 2.91643 6.06258 3.42804 5.39996 3.42804C4.73734 3.42804 4.20015 2.91643 4.20015 2.28536V1.14268C4.20015 0.511607 4.73734 0 5.39996 0ZM18.6 0C19.2627 0 19.7998 0.511607 19.7998 1.14268V2.28536C19.7998 2.91643 19.2627 3.42804 18.6 3.42804C17.9374 3.42804 17.4002 2.91643 17.4002 2.28536V1.14268C17.4002 0.511607 17.9374 0 18.6 0ZM0 8.57143V21.7141C0 22.9762 1.07437 24 2.40017 24H21.5998C22.9251 24 24 22.9768 24 21.7141V8.57143H0ZM7.19994 19.9998C7.19994 20.6314 6.66276 21.1425 6.00014 21.1425H4.80034C4.13716 21.1425 3.60053 20.6309 3.60053 19.9998V18.8571C3.60053 18.2255 4.13772 17.7145 4.80034 17.7145H6.00014C6.66332 17.7145 7.19994 18.2261 7.19994 18.8571V19.9998ZM7.19994 13.7143C7.19994 14.3459 6.66276 14.857 6.00014 14.857H4.80034C4.13716 14.857 3.60053 14.3454 3.60053 13.7143V12.5716C3.60053 11.94 4.13772 11.4289 4.80034 11.4289H6.00014C6.66332 11.4289 7.19994 11.9405 7.19994 12.5716V13.7143ZM13.7997 19.9998C13.7997 20.6314 13.2625 21.1425 12.5999 21.1425H11.4001C10.7369 21.1425 10.2003 20.6309 10.2003 19.9998V18.8571C10.2003 18.2255 10.7375 17.7145 11.4001 17.7145H12.5999C13.2631 17.7145 13.7997 18.2261 13.7997 18.8571V19.9998ZM13.7997 13.7143C13.7997 14.3459 13.2625 14.857 12.5999 14.857H11.4001C10.7369 14.857 10.2003 14.3454 10.2003 13.7143V12.5716C10.2003 11.94 10.7375 11.4289 11.4001 11.4289H12.5999C13.2631 11.4289 13.7997 11.9405 13.7997 12.5716V13.7143ZM20.4 19.9998C20.4 20.6314 19.8628 21.1425 19.2002 21.1425H18.0004C17.3372 21.1425 16.8006 20.6309 16.8006 19.9998V18.8571C16.8006 18.2255 17.3378 17.7145 18.0004 17.7145H19.2002C19.8634 17.7145 20.4 18.2261 20.4 18.8571V19.9998ZM20.4 13.7143C20.4 14.3459 19.8628 14.857 19.2002 14.857H18.0004C17.3372 14.857 16.8006 14.3454 16.8006 13.7143V12.5716C16.8006 11.94 17.3378 11.4289 18.0004 11.4289H19.2002C19.8634 11.4289 20.4 11.9405 20.4 12.5716V13.7143ZM24 7.42875V4.00018C24 2.73804 22.9256 1.71429 21.5998 1.71429H20.9996V2.28589C20.9996 3.54643 19.923 4.57179 18.5995 4.57179C17.2759 4.57179 16.1993 3.54643 16.1993 2.28589V1.71429H7.79956V2.28589C7.79956 3.54643 6.72295 4.57179 5.39939 4.57179C4.07584 4.57179 2.99923 3.54643 2.99923 2.28589V1.71429H2.39904C1.07437 1.71429 0 2.7375 0 4.00018V7.42875H24Z" fill="#002F7C"/>
                          </svg>
                      </span>
                  </div>
              </date-picker>
            </template>
            <template v-else-if="x.model === 'endDate'">
              <date-picker 
                  class="c-ibForm-input__date-picker"
                  v-model.trim="data.form[x.model]"
                  :start-date="data.form.startDate ? data.form.startDate : setDate" 
                  @set-focus="setFocus" 
                  @remove-prefocus="removeFocus" 
                  inline-template
              >
                  <div class="c-ibForm-input__Coverage u-Relative">
                      <input 
                          type="tel" 
                          class="c-ibForm-input__Coverage-input" 
                          :id="x.id"
                          :value="value || ''"
                          autocomplete="off"
                          @input="handleInputEvt" 
                          @blur="$emit('remove-prefocus', 'end')"
                          @focus="$emit('set-focus', 'end')"
                          maxlength="10"
                          :placeholder="x.placeholder || ''"
                      >
                      <span class="o-Icon-menu__date">
                          <svg class="c-ibForm-input__Coverage-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.39996 0C6.06258 0 6.59976 0.511607 6.59976 1.14268V2.28536C6.59976 2.91643 6.06258 3.42804 5.39996 3.42804C4.73734 3.42804 4.20015 2.91643 4.20015 2.28536V1.14268C4.20015 0.511607 4.73734 0 5.39996 0ZM18.6 0C19.2627 0 19.7998 0.511607 19.7998 1.14268V2.28536C19.7998 2.91643 19.2627 3.42804 18.6 3.42804C17.9374 3.42804 17.4002 2.91643 17.4002 2.28536V1.14268C17.4002 0.511607 17.9374 0 18.6 0ZM0 8.57143V21.7141C0 22.9762 1.07437 24 2.40017 24H21.5998C22.9251 24 24 22.9768 24 21.7141V8.57143H0ZM7.19994 19.9998C7.19994 20.6314 6.66276 21.1425 6.00014 21.1425H4.80034C4.13716 21.1425 3.60053 20.6309 3.60053 19.9998V18.8571C3.60053 18.2255 4.13772 17.7145 4.80034 17.7145H6.00014C6.66332 17.7145 7.19994 18.2261 7.19994 18.8571V19.9998ZM7.19994 13.7143C7.19994 14.3459 6.66276 14.857 6.00014 14.857H4.80034C4.13716 14.857 3.60053 14.3454 3.60053 13.7143V12.5716C3.60053 11.94 4.13772 11.4289 4.80034 11.4289H6.00014C6.66332 11.4289 7.19994 11.9405 7.19994 12.5716V13.7143ZM13.7997 19.9998C13.7997 20.6314 13.2625 21.1425 12.5999 21.1425H11.4001C10.7369 21.1425 10.2003 20.6309 10.2003 19.9998V18.8571C10.2003 18.2255 10.7375 17.7145 11.4001 17.7145H12.5999C13.2631 17.7145 13.7997 18.2261 13.7997 18.8571V19.9998ZM13.7997 13.7143C13.7997 14.3459 13.2625 14.857 12.5999 14.857H11.4001C10.7369 14.857 10.2003 14.3454 10.2003 13.7143V12.5716C10.2003 11.94 10.7375 11.4289 11.4001 11.4289H12.5999C13.2631 11.4289 13.7997 11.9405 13.7997 12.5716V13.7143ZM20.4 19.9998C20.4 20.6314 19.8628 21.1425 19.2002 21.1425H18.0004C17.3372 21.1425 16.8006 20.6309 16.8006 19.9998V18.8571C16.8006 18.2255 17.3378 17.7145 18.0004 17.7145H19.2002C19.8634 17.7145 20.4 18.2261 20.4 18.8571V19.9998ZM20.4 13.7143C20.4 14.3459 19.8628 14.857 19.2002 14.857H18.0004C17.3372 14.857 16.8006 14.3454 16.8006 13.7143V12.5716C16.8006 11.94 17.3378 11.4289 18.0004 11.4289H19.2002C19.8634 11.4289 20.4 11.9405 20.4 12.5716V13.7143ZM24 7.42875V4.00018C24 2.73804 22.9256 1.71429 21.5998 1.71429H20.9996V2.28589C20.9996 3.54643 19.923 4.57179 18.5995 4.57179C17.2759 4.57179 16.1993 3.54643 16.1993 2.28589V1.71429H7.79956V2.28589C7.79956 3.54643 6.72295 4.57179 5.39939 4.57179C4.07584 4.57179 2.99923 3.54643 2.99923 2.28589V1.71429H2.39904C1.07437 1.71429 0 2.7375 0 4.00018V7.42875H24Z" fill="#002F7C"/>
                          </svg>
                      </span>
                  </div>
              </date-picker>
            </template>
            <template v-else>
              <date-picker 
                  class="c-ibForm-input__date-picker"
                  v-model.trim="data.form[x.model]"
                  :start-date="x.model === 'returnDate' ? data.form.departureDate : ''" 
                  @set-focus="setFocus" 
                  @remove-prefocus="removeFocus" 
                  inline-template
              >
                  <div class="c-ibForm-input__Coverage u-Relative">
                      <input 
                          type="tel" 
                          class="c-ibForm-input__Coverage-input" 
                          :id="x.id"
                          :value="value || ''"
                          autocomplete="off"
                          @input="handleInputEvt" 
                          @blur="$emit('remove-prefocus', x.id)"
                          @focus="$emit('set-focus', x.id)"
                          maxlength="10"
                          :placeholder="x.placeholder || ''"
                      >
                      <span class="o-Icon-menu__date">
                          <svg class="c-ibForm-input__Coverage-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.39996 0C6.06258 0 6.59976 0.511607 6.59976 1.14268V2.28536C6.59976 2.91643 6.06258 3.42804 5.39996 3.42804C4.73734 3.42804 4.20015 2.91643 4.20015 2.28536V1.14268C4.20015 0.511607 4.73734 0 5.39996 0ZM18.6 0C19.2627 0 19.7998 0.511607 19.7998 1.14268V2.28536C19.7998 2.91643 19.2627 3.42804 18.6 3.42804C17.9374 3.42804 17.4002 2.91643 17.4002 2.28536V1.14268C17.4002 0.511607 17.9374 0 18.6 0ZM0 8.57143V21.7141C0 22.9762 1.07437 24 2.40017 24H21.5998C22.9251 24 24 22.9768 24 21.7141V8.57143H0ZM7.19994 19.9998C7.19994 20.6314 6.66276 21.1425 6.00014 21.1425H4.80034C4.13716 21.1425 3.60053 20.6309 3.60053 19.9998V18.8571C3.60053 18.2255 4.13772 17.7145 4.80034 17.7145H6.00014C6.66332 17.7145 7.19994 18.2261 7.19994 18.8571V19.9998ZM7.19994 13.7143C7.19994 14.3459 6.66276 14.857 6.00014 14.857H4.80034C4.13716 14.857 3.60053 14.3454 3.60053 13.7143V12.5716C3.60053 11.94 4.13772 11.4289 4.80034 11.4289H6.00014C6.66332 11.4289 7.19994 11.9405 7.19994 12.5716V13.7143ZM13.7997 19.9998C13.7997 20.6314 13.2625 21.1425 12.5999 21.1425H11.4001C10.7369 21.1425 10.2003 20.6309 10.2003 19.9998V18.8571C10.2003 18.2255 10.7375 17.7145 11.4001 17.7145H12.5999C13.2631 17.7145 13.7997 18.2261 13.7997 18.8571V19.9998ZM13.7997 13.7143C13.7997 14.3459 13.2625 14.857 12.5999 14.857H11.4001C10.7369 14.857 10.2003 14.3454 10.2003 13.7143V12.5716C10.2003 11.94 10.7375 11.4289 11.4001 11.4289H12.5999C13.2631 11.4289 13.7997 11.9405 13.7997 12.5716V13.7143ZM20.4 19.9998C20.4 20.6314 19.8628 21.1425 19.2002 21.1425H18.0004C17.3372 21.1425 16.8006 20.6309 16.8006 19.9998V18.8571C16.8006 18.2255 17.3378 17.7145 18.0004 17.7145H19.2002C19.8634 17.7145 20.4 18.2261 20.4 18.8571V19.9998ZM20.4 13.7143C20.4 14.3459 19.8628 14.857 19.2002 14.857H18.0004C17.3372 14.857 16.8006 14.3454 16.8006 13.7143V12.5716C16.8006 11.94 17.3378 11.4289 18.0004 11.4289H19.2002C19.8634 11.4289 20.4 11.9405 20.4 12.5716V13.7143ZM24 7.42875V4.00018C24 2.73804 22.9256 1.71429 21.5998 1.71429H20.9996V2.28589C20.9996 3.54643 19.923 4.57179 18.5995 4.57179C17.2759 4.57179 16.1993 3.54643 16.1993 2.28589V1.71429H7.79956V2.28589C7.79956 3.54643 6.72295 4.57179 5.39939 4.57179C4.07584 4.57179 2.99923 3.54643 2.99923 2.28589V1.71429H2.39904C1.07437 1.71429 0 2.7375 0 4.00018V7.42875H24Z" fill="#002F7C"/>
                          </svg>
                      </span>
                  </div>
              </date-picker>
            </template>
          </template>
          <!-- Validations -->
          <div class="o-Valid-msg" :class="[x.additionalClasses]" v-cloak>
            <p :key="k" v-for="(a,k) in x.validations"
               v-if="$v.form[x.model][x.liveErrors ? '$invalid' : '$error'] && $v.form[x.model][a.name] === false"
               >
               <span class='error-check' v-if="(x.liveErrors && $v.form[x.model].$dirty) || !x.liveErrors">
                {{a.text && qResultsLang.errors[a.text] ? qResultsLang.errors[a.text]  : 'Invalid Input'}}
              </span>
            </p>
          </div>
        </div>
        <!-- END main for loop -->
      </div>
      <div v-if="numberOfTripDays && numberOfTripDays > 0" class="c-ibForm-description">
        {{qResultsLang.summaryCoverageDates}}:  {{numberOfTripDays}}  {{(numberOfTripDays > 1 ? qResultsLang.days : qResultsLang.day)}}
      </div>
    </div>
    <div v-if="!hideBorder" class="c-ibForm-bdr-break"></div>
  </div>
</template>
<script>
import datePicker from '../../../components/forms/component.date-picker.vue';
import { homeCountryPlans } from './img/all/section-configs';
import PhoneCode from '../../../components/forms/component.phone-code-app.vue';
import { convertDateToEN } from '../../../helper-functions/helper-functions';
export default {
  components: {
      'date-picker': datePicker,
      'phone-code': PhoneCode
      },
  props: ['heading',
          'fields',
          'first-section',
          'no-padding',
          'no-padding-bottom',
          'data',
          'isusorterritories',
          '$v',
          'heading-modal',
          'image-in-input',
          'hide-border',
          'readonly'
          ],
  name: 'input-section',
  data: function(){
    return {
      ibjs: window.ibJS,
      qResultsLang: window.qResultsLang,
      sizeLarge: window.innerWidth > 991 ? true : false,
      headingModalExists: false,
      currentStep: window.currentStep,
      labelsToMatch: [
        {label1: 'firstNameLabel', label2: 'lastNameLabel'},
        {label1: 'email1Label', label2: 'email2Label'},
        {label1: 'departResidenceCountryLabel', label2: 'returnResidenceCountryLabel'},
        {label1: 'internationalInsuranceProviderLabel', label2: 'expirationOfCurrentCoverageLabel'}

      ],
      setDate: new Date(),
      placeholder: {
            label: {
                start: window.qResultsLang.startDate,
                end: window.qResultsLang.endDate
            },
            format: window.globalLanguage.lang === 'en' ? 'mm/dd/yyyy' : window.globalLanguage.lang === 'es' ? 'dd/mm/yyyy' : 'yyyy/mm/dd' 
        }
    }
  },
  created: function(){
    if (this.headingModal) this.headingModalExists = true;
    this.setSpanishLabelsToMatch();
  },
  mounted: function(){
    this.forceLabelHeightsMatch();
    
    if (window.ibJS?.planConfig?.companyCode === "IMG") {
      const todaysDate = new Date();
      this.setDate = new Date(`${todaysDate.getMonth()+1}/${todaysDate.getDate()}/${todaysDate.getFullYear()}`);
    }
  },
  computed: {
    numberOfTripDays() {
        if(!this.$parent.form.startDate || !this.$parent.form.endDate) return null;
        if(this.$parent.$v.form.startDate?.$invalid || this.$parent.$v.form.endDate?.$invalid) return null;
        if(ibJS.application?.currentStep == 3 || ibJS.application?.currentStep == 5) return null;
        let startTime = new Date(convertDateToEN(this.$parent.form.startDate));
        let endTime = new Date(convertDateToEN(this.$parent.form.endDate));
        return Math.floor((endTime - startTime) / (1000 * 60 * 60 * 24)) + 1;
    }
  },
  methods: {
    setSpanishLabelsToMatch: function() {
      var spanishLabels = [
        {label1: 'firstNameLabel', label2: 'lastNameLabel'},
        {label1: 'email1Label', label2: 'email2Label'}
        ]
      if(window.globalLanguage.lang === 'es') {
        this.labelsToMatch = this.labelsToMatch.concat(spanishLabels);
      }
    },
    forceLabelHeightsMatch: function(){
      var self = this;
      var filter = false;

      for(var i = 0; i < this.labelsToMatch.length; i++) {
        if(document.getElementById(this.labelsToMatch[i].label1)) {
          filter = true;
          break;
        }
      }

      if(filter) {
        self.entangleHeights(self.labelsToMatch);
        window.addEventListener('resize', function() {
          self.entangleHeights(self.labelsToMatch);
          //sizeLarge is included to add additional word spacing to depart from residence country label
          self.sizeLarge = window.innerWidth > 991 ? true : false;
        });
      }
    },
    entangleHeights: function(labelIdArray) {
      var self = this;
      //APP-1119 Function matches label heights to prevent staggered inputs.
      labelIdArray.forEach(function(x,i) {
        var a = document.getElementById(x.label1);
        var b = document.getElementById(x.label2);
        if(a && b) {
          a.style.height = 'auto';
          b.style.height = 'auto';

          if(a.offsetHeight > b.offsetHeight) {
            b.style.height = a.offsetHeight+'px';
          }
          else if(a.offsetHeight < b.offsetHeight) {
            a.style.height = b.offsetHeight+'px';
          }
        }
      })
    },
    showHeadingModal: function() {
      var self = this;
       self.$emit('show-modal','/guide/terms?section='+self.headingModal)
    },
    checkBooleanFromString: function(x){
      return typeof(x) !== 'boolean' ?  eval(x): x
    },
    makeContactAjaxCall (phoneNo) {
      this.$emit('phone-updated', phoneNo);
    },
    setFocus (id) {
        const thisDate = document.querySelector(`#${id}`);
        if (thisDate) thisDate.placeholder = this.placeholder.format;
    },
    removeFocus (id) {
        const thisDate = document.querySelector(`#${id}`);
        if (thisDate) thisDate.placeholder = this.placeholder.label[id];
    }
  }
}
</script>
<style lang="scss" scoped>
  .o-Valid-msg{
    &:first-child{
      display: block;
    }

    p:not(:first-child){
      display: none;
    }
  }
</style>
